import React from 'react'
import styles from '../componentsStyles/Projects.module.css'

import { BsGithub } from 'react-icons/bs'


const ProjectsOthers = () => {

  return (
    <div className={styles.others}>
        <h3> Other projects </h3>
        <button> <a className={styles.link} href="https://github.com/matheusgosk8"><BsGithub/>  Visit my github profile too see other projects</a></button>
    </div>
  )
}

export default ProjectsOthers